// src/components/XemAnh.js
import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import AnhCoKhoa from "./AnhCoKhoa";

// ============================================================
// 🔍 XEM ẢNH TO HẾT MÀN HÌNH (Đợt N5, 14/09/2026 — mockup màn ②)
// ------------------------------------------------------------
// Mẹ bấm 📎 cạnh số tiền → ảnh hoá đơn mở to, kéo hai ngón để phóng to
// đọc số. Đóng bằng nút ✕, bấm ra ngoài ảnh, hoặc phím Esc.
//
// ⚠️ KHÔNG chặn cử chỉ phóng to của trình duyệt (không `touch-action: none`,
// không `user-scalable=no`) — người lớn tuổi đọc hoá đơn CẦN phóng to.
//
// N7 (15/09): bài Sân chơi có tới 6 ảnh → truyền `onTruoc` / `onSau` / `thuTu`
// là hiện hai nút ‹ › to (và phím ← →). Không truyền thì như cũ.
// ============================================================

// `bieuTuong`: 🧾 cho hoá đơn (mặc định, N5), 💡 cho mẹo vặt (N6), 🎉 Sân chơi (N7).
function XemAnh({ anhId, tieuDe, onDong, bieuTuong = "🧾", onTruoc, onSau, thuTu }) {
  // Giữ các hàm trong ref: nơi gọi thường truyền một hàm viết tại chỗ, mỗi
  // lần vẽ lại là một hàm mới — đưa thẳng vào useEffect thì khoá/mở cuộn
  // trang chạy lại liên tục.
  const hamRef = useRef({ onDong, onTruoc, onSau });
  hamRef.current = { onDong, onTruoc, onSau };

  useEffect(() => {
    const phim = (e) => {
      if (e.key === "Escape") hamRef.current.onDong();
      if (e.key === "ArrowLeft" && hamRef.current.onTruoc) hamRef.current.onTruoc();
      if (e.key === "ArrowRight" && hamRef.current.onSau) hamRef.current.onSau();
    };
    window.addEventListener("keydown", phim);
    // Khoá cuộn trang phía sau, trả lại khi đóng.
    const cu = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", phim);
      document.body.style.overflow = cu;
    };
  }, []);

  const coLuot = Boolean(onTruoc || onSau);

  // ⚠️ VẼ THẲNG VÀO <body> (createPortal), không vẽ tại chỗ.
  // Khối chi tiêu nằm trong `.card`, mà `.card:hover` có `transform` — phần tử
  // `position: fixed` nằm trong một khung có transform thì bị giam trong khung
  // đó: "hết màn hình" thành "hết cái thẻ", và nhảy lên xuống khi rê chuột.
  return createPortal(
    <div className="xem-anh-nen" onClick={onDong} role="dialog" aria-label={tieuDe}>
      <div className="xem-anh-dau" onClick={(e) => e.stopPropagation()}>
        <span className="xem-anh-tieu-de">
          {bieuTuong} {tieuDe}
          {thuTu && ` · ${thuTu}`}
        </span>
        <button className="xem-anh-dong" onClick={onDong}>
          ✕ Đóng
        </button>
      </div>
      <div className="xem-anh-khung" onClick={(e) => e.stopPropagation()}>
        {coLuot && (
          <button className="xem-anh-luot" onClick={onTruoc} disabled={!onTruoc} aria-label="Ảnh trước">
            ‹
          </button>
        )}
        {/* key: đổi ảnh thì dựng lại, không hiện ảnh cũ trong lúc tải ảnh mới */}
        <AnhCoKhoa key={anhId} anhId={anhId} moTa={tieuDe} className="xem-anh-hinh" />
        {coLuot && (
          <button className="xem-anh-luot" onClick={onSau} disabled={!onSau} aria-label="Ảnh sau">
            ›
          </button>
        )}
      </div>
    </div>,
    document.body,
  );
}

export default XemAnh;
